module.exports = __webpack_public_path__ + "img/comming.416f7a1d.png";